export default __webpack_public_path__ + "a03db4f1129065c21801539692e44fec.svg";